module.exports = __webpack_public_path__ + "img/google-play-badge_en.1e91d02c.png";